<template>
  <div class="flex pb-2 flex-row">
    <div
      class="flex flex-1"
      :class="{
        'flex-grow-2': columns === '2',
        'flex-grow': columns !== '2',
      }"
    >
      <slot name="first"></slot>
    </div>
    <div class="flex flex-1 pl-3 flex-grow">
      <slot name="second"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: ['columns'],
};
</script>
